unit UPersonalDataForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, UMainConfig, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, Vcl.Imaging.pngimage, Vcl.Controls, Types, Vcl.Grids,
  UStampModel, WEBLib.Grids, WEBLib.Buttons;

type
  TPersonalDataForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlStatus: TPanel;
    sgStatus: TStringGrid;
    pnlLogin: TPanel;
    WebLabel1: TLabel;
    edtRemote_User: TEdit;
    pnlName: TPanel;
    WebLabel2: TLabel;
    edtPersonalNr: TEdit;
    WebLabel3: TLabel;
    edtName: TEdit;
    pnlData: TPanel;
    WebLabel4: TLabel;
    edtStrasse: TEdit;
    WebLabel5: TLabel;
    edtPlz: TEdit;
    WebLabel6: TLabel;
    edtOrt: TEdit;
    WebLabel7: TLabel;
    edtTelefon: TEdit;
    WebLabel8: TLabel;
    edtHandy: TEdit;
    WebLabel9: TLabel;
    edtEmail: TEdit;
    chkInfoMail: TCheckBox;
    btnEditRemuteUser: TBitBtn;
    btnEditPassword: TBitBtn;
    btnStore: TBitBtn;
    procedure WebFormResize(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
    procedure edtPlzKeyPress(Sender: TObject; var Key: Char);
    procedure edtStrasseChange(Sender: TObject);
    procedure edtTelefonKeyPress(Sender: TObject; var Key: Char);
    procedure btnStoreClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormShow(Sender: TObject);
    [Async]
    procedure btnEditRemuteUserClick(Sender: TObject); async;
    [Async]
    procedure btnEditPasswordClick(Sender: TObject); async;
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
    procedure WebFormCreate(Sender: TObject);
  private
    FMainConfig: TMainConfig;
    FFakStamp: TStampModel;
    FStamp: TStampModel;
    function CheckMask: Boolean;
    function GetMask: Boolean;
    procedure GetLastFakStamp;
    procedure GetStatus;
    procedure SetMask;
    procedure StoreCallback(Sender: TObject);
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetFakStamp(const Value: TStampModel);
    procedure SetStamp(const Value: TStampModel);
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property Stamp: TStampModel read FStamp write SetStamp;
    property FakStamp: TStampModel read FFakStamp write SetFakStamp;
  protected procedure LoadDFMValues; override; end;

var
  PersonalDataForm: TPersonalDataForm;

implementation

{$R *.dfm}

uses
  UUserModel, UEditRemoteUserForm, UEditPasswordForm, UEssentialHelper,
  UGridHelper;

{ TPersonalDataForm }

procedure TPersonalDataForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure TPersonalDataForm.btnEditPasswordClick(Sender: TObject);
var
  frm: TEditPasswordForm;
begin
  Self.MainConfig.TimerReset;
  frm := TEditPasswordForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TEditPasswordForm, frm.Load);
  frm.MainConfig := Self.MainConfig;
  try
    Self.Hide;
    await(TModalResult, frm.Execute);
  finally
    frm.Free;
    Self.Show;
  end;
end;

procedure TPersonalDataForm.btnEditRemuteUserClick(Sender: TObject);
var
  frm: TEditRemoteUserForm;
begin
  Self.MainConfig.TimerReset;
  frm := TEditRemoteUserForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TEditRemoteUserForm, frm.Load);
  frm.MainConfig := Self.MainConfig;
  try
    Self.Hide;
    if await(TModalResult, frm.Execute) = mrOK then
      edtRemote_User.Text := Self.MainConfig.User.Remote_User;
  finally
    frm.Free;
    Self.Show;
  end;
end;

procedure TPersonalDataForm.btnStoreClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  if CheckMask and GetMask then
  begin
    Self.MainConfig.User.OnPropertyChanged := StoreCallback;
    Self.MainConfig.User.Update(Self.MainConfig.Uri);
  end;
end;

function TPersonalDataForm.CheckMask: Boolean;
begin
  Result := true;
end;

procedure TPersonalDataForm.edtPlzKeyPress(Sender: TObject; var Key: Char);
begin
  if not(Key in ['0' .. '9', #8]) then
    Key := #0;
end;

procedure TPersonalDataForm.edtStrasseChange(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  btnStore.Enabled := true;
end;

procedure TPersonalDataForm.edtTelefonKeyPress(Sender: TObject; var Key: Char);
begin
  if not(Key in ['0' .. '9', #8, '/', '+', '-', ' ']) then
    Key := #0;
end;

procedure TPersonalDataForm.GetLastFakStamp;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.FakStamp := Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastFakStamp(Self.MainConfig.Uri);
end;

function TPersonalDataForm.GetMask: Boolean;
begin
  Result := true;
  Self.MainConfig.User.Strasse := edtStrasse.Text;
  Self.MainConfig.User.Plz := edtPlz.Text;
  Self.MainConfig.User.Ort := edtOrt.Text;
  Self.MainConfig.User.Telefon := edtTelefon.Text;
  Self.MainConfig.User.Handy := edtHandy.Text;
  Self.MainConfig.User.Email := edtEmail.Text;
  Self.MainConfig.User.InfoMail := chkInfoMail.Checked;
end;

procedure TPersonalDataForm.GetStatus;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.Stamp := Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastStamp(Self.MainConfig.Uri);
end;

procedure TPersonalDataForm.SetFakStamp(const Value: TStampModel);
begin
  FFakStamp := Value;
end;

procedure TPersonalDataForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  if Self.MainConfig.CommonConfig.WorkOrderTimes then
    Self.GetLastFakStamp;
  Self.WebFormResize(Self);
  Self.GetStatus;
  Self.SetMask;
end;

procedure TPersonalDataForm.SetMask;
begin
  edtRemote_User.Text := Self.MainConfig.User.Remote_User;
  edtPersonalNr.Text := Self.MainConfig.User.PersonalNr;
  edtName.Text := Self.MainConfig.User.ToString;
  edtStrasse.Text := Self.MainConfig.User.Strasse;
  edtPlz.Text := Self.MainConfig.User.Plz;
  edtOrt.Text := Self.MainConfig.User.Ort;
  edtTelefon.Text := Self.MainConfig.User.Telefon;
  edtHandy.Text := Self.MainConfig.User.Handy;
  edtEmail.Text := Self.MainConfig.User.Email;
  chkInfoMail.Checked := Self.MainConfig.User.InfoMail;
  btnStore.Enabled := false;
end;

procedure TPersonalDataForm.SetStamp(const Value: TStampModel);
begin
  FStamp := Value;
end;

procedure TPersonalDataForm.StoreCallback(Sender: TObject);
begin
  if Sender is TUserModel then
  begin
    if (Sender as TUserModel).Result.ResultValue then
      Self.Close
    else
      MessageDLG((Sender as TUserModel).Result.ResultMessage,
        mtWarning, [mbOK]);
  end;
end;

procedure TPersonalDataForm.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
  if Self.MainConfig <> nil then
    Self.MainConfig.User.OnPropertyChanged := nil;
end;

procedure TPersonalDataForm.WebFormCreate(Sender: TObject);
begin
  Self.Stamp := nil;
  Self.FakStamp := nil;
end;

procedure TPersonalDataForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TPersonalDataForm.WebFormResize(Sender: TObject);
var
  i: Integer;
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Persönliche Daten';
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, true, pnlStatus,
        Self.MainConfig.User);
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Persönliche Daten';
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, false, pnlStatus,
        Self.MainConfig.User);
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := 64;
  lblHeader.Width := pnlHeader.ClientWidth - btnBack.Width - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  i := (Self.ClientWidth - pnlData.Width) div 2;
  if i < 0 then
    i := 0;
  pnlLogin.Left := i;
  pnlName.Left := i;
  pnlData.Left := i;
  i := Self.ClientHeight - pnlHeader.Height - pnlStatus.Height;
  i := i - pnlLogin.Height - pnlName.Height - pnlData.Height;
  if pnlFooter.Visible then
    i := i - pnlFooter.Height;
  i := i div 2;
  if i < 0 then
    i := 0;
  pnlLogin.Top := pnlStatus.Top + pnlStatus.Height + i;
  pnlName.Top := pnlLogin.Top + pnlLogin.Height;
  pnlData.Top := pnlName.Top + pnlName.Height;
end;

procedure TPersonalDataForm.WebFormShow(Sender: TObject);
begin
  Self.WebFormResize(Sender);
end;

procedure TPersonalDataForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlStatus := TPanel.Create(Self);
  sgStatus := TStringGrid.Create(Self);
  pnlLogin := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  edtRemote_User := TEdit.Create(Self);
  btnEditRemuteUser := TBitBtn.Create(Self);
  pnlName := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  edtPersonalNr := TEdit.Create(Self);
  edtName := TEdit.Create(Self);
  btnEditPassword := TBitBtn.Create(Self);
  pnlData := TPanel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  edtStrasse := TEdit.Create(Self);
  edtPlz := TEdit.Create(Self);
  edtOrt := TEdit.Create(Self);
  edtTelefon := TEdit.Create(Self);
  edtHandy := TEdit.Create(Self);
  edtEmail := TEdit.Create(Self);
  chkInfoMail := TCheckBox.Create(Self);
  btnStore := TBitBtn.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlStatus.BeforeLoadDFMValues;
  sgStatus.BeforeLoadDFMValues;
  pnlLogin.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  edtRemote_User.BeforeLoadDFMValues;
  btnEditRemuteUser.BeforeLoadDFMValues;
  pnlName.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  edtPersonalNr.BeforeLoadDFMValues;
  edtName.BeforeLoadDFMValues;
  btnEditPassword.BeforeLoadDFMValues;
  pnlData.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  edtStrasse.BeforeLoadDFMValues;
  edtPlz.BeforeLoadDFMValues;
  edtOrt.BeforeLoadDFMValues;
  edtTelefon.BeforeLoadDFMValues;
  edtHandy.BeforeLoadDFMValues;
  edtEmail.BeforeLoadDFMValues;
  chkInfoMail.BeforeLoadDFMValues;
  btnStore.BeforeLoadDFMValues;
  try
    Name := 'PersonalDataForm';
    Width := 640;
    Height := 529;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnScroll', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UPersonalDataForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Pers'#246'nliche Daten';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UPersonalDataForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 505;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlStatus.SetParentComponent(Self);
    pnlStatus.Name := 'pnlStatus';
    pnlStatus.Left := 0;
    pnlStatus.Top := 64;
    pnlStatus.Width := 640;
    pnlStatus.Height := 28;
    pnlStatus.Align := alTop;
    pnlStatus.Caption := 'pnlStatus';
    pnlStatus.ChildOrder := 2;
    pnlStatus.ShowCaption := False;
    sgStatus.SetParentComponent(pnlStatus);
    sgStatus.Name := 'sgStatus';
    sgStatus.Left := 0;
    sgStatus.Top := 0;
    sgStatus.Width := 640;
    sgStatus.Height := 28;
    sgStatus.Align := alClient;
    sgStatus.ColCount := 4;
    sgStatus.FixedCols := 0;
    sgStatus.RowCount := 2;
    sgStatus.FixedRows := 0;
    sgStatus.Font.Charset := ANSI_CHARSET;
    sgStatus.Font.Color := clNavy;
    sgStatus.Font.Height := -16;
    sgStatus.Font.Name := 'Segoe UI Semibold';
    sgStatus.Font.Style := [fsBold];
    sgStatus.Options := [goRangeSelect,goFixedRowDefAlign];
    sgStatus.ParentFont := False;
    sgStatus.ScrollBars := ssNone;
    sgStatus.TabOrder := 0;
    sgStatus.RangeEdit.Max := 100.000000000000000000;
    sgStatus.RangeEdit.Step := 1.000000000000000000;
    sgStatus.HeightPercent := 100.000000000000000000;
    sgStatus.WidthPercent := 100.000000000000000000;
    pnlLogin.SetParentComponent(Self);
    pnlLogin.Name := 'pnlLogin';
    pnlLogin.Left := 0;
    pnlLogin.Top := 92;
    pnlLogin.Width := 384;
    pnlLogin.Height := 55;
    pnlLogin.Caption := 'pnlLogin';
    pnlLogin.ChildOrder := 3;
    pnlLogin.ShowCaption := False;
    WebLabel1.SetParentComponent(pnlLogin);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 8;
    WebLabel1.Width := 95;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Ihr Anmeldename';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    edtRemote_User.SetParentComponent(pnlLogin);
    edtRemote_User.Name := 'edtRemote_User';
    edtRemote_User.Left := 8;
    edtRemote_User.Top := 24;
    edtRemote_User.Width := 240;
    edtRemote_User.Height := 22;
    edtRemote_User.ChildOrder := 1;
    edtRemote_User.Enabled := False;
    edtRemote_User.HeightPercent := 100.000000000000000000;
    edtRemote_User.Text := 'edtRemote_User';
    edtRemote_User.WidthPercent := 100.000000000000000000;
    btnEditRemuteUser.SetParentComponent(pnlLogin);
    btnEditRemuteUser.Name := 'btnEditRemuteUser';
    btnEditRemuteUser.Left := 256;
    btnEditRemuteUser.Top := 3;
    btnEditRemuteUser.Width := 120;
    btnEditRemuteUser.Height := 48;
    btnEditRemuteUser.Caption := '<div> Anmeldenamen '#228'ndern</div>';
    btnEditRemuteUser.Color := clNone;
    btnEditRemuteUser.Glyph.LoadFromFile('UPersonalDataForm.pnlLogin.btnEditRemuteUser.Glyph.png');
    btnEditRemuteUser.GlyphSize := 24;
    btnEditRemuteUser.HeightPercent := 100.000000000000000000;
    btnEditRemuteUser.WidthPercent := 100.000000000000000000;
    SetEvent(btnEditRemuteUser, Self, 'OnClick', 'btnEditRemuteUserClick');
    pnlName.SetParentComponent(Self);
    pnlName.Name := 'pnlName';
    pnlName.Left := 0;
    pnlName.Top := 147;
    pnlName.Width := 384;
    pnlName.Height := 55;
    pnlName.Caption := 'pnlName';
    pnlName.ChildOrder := 4;
    pnlName.ShowCaption := False;
    WebLabel2.SetParentComponent(pnlName);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 8;
    WebLabel2.Top := 8;
    WebLabel2.Width := 66;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Personal-Nr.';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(pnlName);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 96;
    WebLabel3.Top := 8;
    WebLabel3.Width := 32;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Name';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    edtPersonalNr.SetParentComponent(pnlName);
    edtPersonalNr.Name := 'edtPersonalNr';
    edtPersonalNr.Left := 8;
    edtPersonalNr.Top := 24;
    edtPersonalNr.Width := 80;
    edtPersonalNr.Height := 22;
    edtPersonalNr.ChildOrder := 1;
    edtPersonalNr.Enabled := False;
    edtPersonalNr.HeightPercent := 100.000000000000000000;
    edtPersonalNr.Text := 'edtPersonalNr';
    edtPersonalNr.WidthPercent := 100.000000000000000000;
    edtName.SetParentComponent(pnlName);
    edtName.Name := 'edtName';
    edtName.Left := 96;
    edtName.Top := 24;
    edtName.Width := 152;
    edtName.Height := 22;
    edtName.ChildOrder := 1;
    edtName.Enabled := False;
    edtName.HeightPercent := 100.000000000000000000;
    edtName.Text := 'edtPersonalNr';
    edtName.WidthPercent := 100.000000000000000000;
    btnEditPassword.SetParentComponent(pnlName);
    btnEditPassword.Name := 'btnEditPassword';
    btnEditPassword.Left := 256;
    btnEditPassword.Top := 3;
    btnEditPassword.Width := 120;
    btnEditPassword.Height := 48;
    btnEditPassword.Caption := '<div>Passwort '#228'ndern</div>';
    btnEditPassword.Color := clNone;
    btnEditPassword.Glyph.LoadFromFile('UPersonalDataForm.pnlName.btnEditPassword.Glyph.png');
    btnEditPassword.GlyphSize := 24;
    btnEditPassword.HeightPercent := 100.000000000000000000;
    btnEditPassword.WidthPercent := 100.000000000000000000;
    SetEvent(btnEditPassword, Self, 'OnClick', 'btnEditPasswordClick');
    pnlData.SetParentComponent(Self);
    pnlData.Name := 'pnlData';
    pnlData.Left := 0;
    pnlData.Top := 202;
    pnlData.Width := 384;
    pnlData.Height := 297;
    pnlData.Caption := 'pnlData';
    pnlData.ChildOrder := 6;
    pnlData.ShowCaption := False;
    WebLabel4.SetParentComponent(pnlData);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 8;
    WebLabel4.Top := 8;
    WebLabel4.Width := 36;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Strasse';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(pnlData);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 8;
    WebLabel5.Top := 56;
    WebLabel5.Width := 20;
    WebLabel5.Height := 15;
    WebLabel5.Caption := 'PLZ';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(pnlData);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 64;
    WebLabel6.Top := 56;
    WebLabel6.Width := 17;
    WebLabel6.Height := 15;
    WebLabel6.Caption := 'Ort';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(pnlData);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 8;
    WebLabel7.Top := 104;
    WebLabel7.Width := 39;
    WebLabel7.Height := 15;
    WebLabel7.Caption := 'Telefon';
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(pnlData);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 8;
    WebLabel8.Top := 152;
    WebLabel8.Width := 35;
    WebLabel8.Height := 15;
    WebLabel8.Caption := 'Handy';
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(pnlData);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 8;
    WebLabel9.Top := 200;
    WebLabel9.Width := 73;
    WebLabel9.Height := 15;
    WebLabel9.Caption := 'E-Mailadresse';
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.WidthPercent := 100.000000000000000000;
    edtStrasse.SetParentComponent(pnlData);
    edtStrasse.Name := 'edtStrasse';
    edtStrasse.Left := 8;
    edtStrasse.Top := 24;
    edtStrasse.Width := 240;
    edtStrasse.Height := 22;
    edtStrasse.ChildOrder := 1;
    edtStrasse.HeightPercent := 100.000000000000000000;
    edtStrasse.MaxLength := 30;
    edtStrasse.Text := 'edtStrasse';
    edtStrasse.WidthPercent := 100.000000000000000000;
    SetEvent(edtStrasse, Self, 'OnChange', 'edtStrasseChange');
    edtPlz.SetParentComponent(pnlData);
    edtPlz.Name := 'edtPlz';
    edtPlz.Left := 8;
    edtPlz.Top := 72;
    edtPlz.Width := 48;
    edtPlz.Height := 22;
    edtPlz.ChildOrder := 3;
    edtPlz.HeightPercent := 100.000000000000000000;
    edtPlz.MaxLength := 5;
    edtPlz.Text := 'edtPlz';
    edtPlz.WidthPercent := 100.000000000000000000;
    SetEvent(edtPlz, Self, 'OnChange', 'edtStrasseChange');
    SetEvent(edtPlz, Self, 'OnKeyPress', 'edtPlzKeyPress');
    edtOrt.SetParentComponent(pnlData);
    edtOrt.Name := 'edtOrt';
    edtOrt.Left := 64;
    edtOrt.Top := 72;
    edtOrt.Width := 184;
    edtOrt.Height := 22;
    edtOrt.ChildOrder := 5;
    edtOrt.HeightPercent := 100.000000000000000000;
    edtOrt.MaxLength := 50;
    edtOrt.Text := 'edtOrt';
    edtOrt.WidthPercent := 100.000000000000000000;
    SetEvent(edtOrt, Self, 'OnChange', 'edtStrasseChange');
    edtTelefon.SetParentComponent(pnlData);
    edtTelefon.Name := 'edtTelefon';
    edtTelefon.Left := 8;
    edtTelefon.Top := 120;
    edtTelefon.Width := 240;
    edtTelefon.Height := 22;
    edtTelefon.ChildOrder := 7;
    edtTelefon.HeightPercent := 100.000000000000000000;
    edtTelefon.MaxLength := 15;
    edtTelefon.Text := 'edtTelefon';
    edtTelefon.WidthPercent := 100.000000000000000000;
    SetEvent(edtTelefon, Self, 'OnChange', 'edtStrasseChange');
    SetEvent(edtTelefon, Self, 'OnKeyPress', 'edtTelefonKeyPress');
    edtHandy.SetParentComponent(pnlData);
    edtHandy.Name := 'edtHandy';
    edtHandy.Left := 8;
    edtHandy.Top := 168;
    edtHandy.Width := 240;
    edtHandy.Height := 22;
    edtHandy.ChildOrder := 7;
    edtHandy.HeightPercent := 100.000000000000000000;
    edtHandy.MaxLength := 30;
    edtHandy.Text := 'edtTelefon';
    edtHandy.WidthPercent := 100.000000000000000000;
    SetEvent(edtHandy, Self, 'OnChange', 'edtStrasseChange');
    SetEvent(edtHandy, Self, 'OnKeyPress', 'edtTelefonKeyPress');
    edtEmail.SetParentComponent(pnlData);
    edtEmail.Name := 'edtEmail';
    edtEmail.Left := 8;
    edtEmail.Top := 216;
    edtEmail.Width := 240;
    edtEmail.Height := 22;
    edtEmail.ChildOrder := 11;
    edtEmail.HeightPercent := 100.000000000000000000;
    edtEmail.MaxLength := 50;
    edtEmail.Text := 'edtEmail';
    edtEmail.WidthPercent := 100.000000000000000000;
    SetEvent(edtEmail, Self, 'OnChange', 'edtStrasseChange');
    chkInfoMail.SetParentComponent(pnlData);
    chkInfoMail.Name := 'chkInfoMail';
    chkInfoMail.Left := 3;
    chkInfoMail.Top := 244;
    chkInfoMail.Width := 240;
    chkInfoMail.Height := 22;
    chkInfoMail.Caption := 'Auswertungen erhalten';
    chkInfoMail.ChildOrder := 12;
    chkInfoMail.HeightPercent := 100.000000000000000000;
    chkInfoMail.WidthPercent := 100.000000000000000000;
    SetEvent(chkInfoMail, Self, 'OnClick', 'edtStrasseChange');
    btnStore.SetParentComponent(pnlData);
    btnStore.Name := 'btnStore';
    btnStore.Left := 256;
    btnStore.Top := 244;
    btnStore.Width := 120;
    btnStore.Height := 48;
    btnStore.Caption := 'Speichern';
    btnStore.Color := clNone;
    btnStore.Glyph.LoadFromFile('UPersonalDataForm.pnlData.btnStore.Glyph.png');
    btnStore.GlyphSize := 32;
    btnStore.HeightPercent := 100.000000000000000000;
    btnStore.WidthPercent := 100.000000000000000000;
    SetEvent(btnStore, Self, 'OnClick', 'btnStoreClick');
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlStatus.AfterLoadDFMValues;
    sgStatus.AfterLoadDFMValues;
    pnlLogin.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    edtRemote_User.AfterLoadDFMValues;
    btnEditRemuteUser.AfterLoadDFMValues;
    pnlName.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    edtPersonalNr.AfterLoadDFMValues;
    edtName.AfterLoadDFMValues;
    btnEditPassword.AfterLoadDFMValues;
    pnlData.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    edtStrasse.AfterLoadDFMValues;
    edtPlz.AfterLoadDFMValues;
    edtOrt.AfterLoadDFMValues;
    edtTelefon.AfterLoadDFMValues;
    edtHandy.AfterLoadDFMValues;
    edtEmail.AfterLoadDFMValues;
    chkInfoMail.AfterLoadDFMValues;
    btnStore.AfterLoadDFMValues;
  end;
end;

end.
